import React from "react";
import { Link } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import moment from "moment";
import 'moment/locale/pt-br';

import PageAlert from "presentation/components/page-alert";

import CancelButton from "presentation/components/buttons/cancel";

import { baseCalendar } from 'presentation/pages/academic-periods/functions/academic-periods';


class AcademicPeriodSchoolDaysForm extends React.Component {
    constructor(props) {
        super(props);
    }


    getHeaders = () => {
        var headers = [];
        var monthLables = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

        for (let i = 0; i < 12; i++) {
            headers.push(<th className="text-center" key={i}>{monthLables[i]}</th>);
        }
        return headers;
    }

    getRowElement = (day, month, year) => {
        const { getStateValue, setStateValue } = this;
        var dateValue = `${day}-${month}-${year}`;
        var date = moment(dateValue, 'D-MM-YYYY');

        if (date.isValid()) {
            return (
                <>
                    <small>{date.locale('pt-br').format('dddd').substring(0, 3)}</small>
                    <Form.Check // prettier-ignore
                        type="switch"
                        checked={getStateValue(day, month, year)}
                        onChange={(e) => setStateValue(day, month, year, e.target.checked)}
                        id={`school-day-switch-${dateValue}`}
                    />
                </>
            );
        }
        return "";
    }

    getStateValue = (day, month, year) => {

        let { component } = this.props;
        let { schoolDays } = component.state;
        let existing = schoolDays.filter(x => x.day == day && x.month == month && x.year == year)[0];
        return existing ? existing.isSchoolDay : undefined;
    }

    setStateValue = (day, month, year, newValue) => {
        let { component } = this.props;
        let { schoolDays } = component.state;

        let existing = schoolDays.filter(x => x.day == day && x.month == month && x.year == year)[0];
        existing.isSchoolDay = newValue;

        let calendarWithoutExisting = schoolDays.filter(x => !(x.day == day && x.month == month && x.year == year));
        component.setState({ schoolDays: [...calendarWithoutExisting, existing] });

    }

    getTableRows = (year, yearMonths) => {
        const { getMonthRowElement } = this;
        var rows = []
        for (let i = 1; i <= 31; i++) {
            rows.push(<tr key={i}><td><strong>{i}</strong></td>{getMonthRowElement(i, year, yearMonths)}</tr>);
        }
        return rows;
    }

    getMonthRowElement = (day, year, yearMonths) => {
        const { getRowElement } = this;
        var tds = [];

        for (let i = 0; i < 12; i++) {
            var month = i + 1;
            var validMonth = yearMonths.filter(x => x.month == month && x.year == year)[0];
            var cellValue = "";
            if (validMonth) {
                cellValue = getRowElement(day, month, year);
            }
            tds.push(<td className="text-center" key={month}>{cellValue}</td>);
        }

        return tds;
    }

    render() {
        let { loading, academicPeriod, isSystemGenerated, handleSubmit } = this.props;
        const { getTableRows, getHeaders } = this;

        var baseCalendarData = baseCalendar(academicPeriod.startDate, academicPeriod.endDate);
        var defaultSelectedMessage = "Parece que os dias letivos desse período acadêmico ainda não foram configurados. <br />Trouxemos uma tabela preenchida com todos os dias para facilitar a sua vida, <strong>mas se você sair dessa tela sem clicar no botão de salvar, essa sugestão não será considerada pelo sistema </strong> e o período acadêmico continuará sem nenhuma configuração de dias letivos!";

        return (
            <Form className="mb-5">
                {isSystemGenerated && <PageAlert className="m-b-20" message={"Sem informações no banco de dados"} description={defaultSelectedMessage} type="info" />}
                <h4>Dias letivos do período acadêmico {academicPeriod.name}</h4>
                <p>Selecione quais dias do período acadêmico serão dias letivos na tabela abaixo</p>
                {baseCalendarData.years.length > 0 && baseCalendarData.years.map((yearItem, i) => {
                    var yearMonths = baseCalendarData.months.filter(x => x.year == yearItem);
                    return (
                        <div key={i}>
                            <table className="table table-bordered mb-5">
                                <thead>
                                    <tr>
                                        <th>{yearItem}</th>
                                        {getHeaders(yearMonths)}
                                    </tr>
                                </thead>
                                <tbody>
                                    {getTableRows(yearItem, yearMonths)}
                                </tbody>

                            </table>
                        </div>
                    )
                })}

                <div className="mt-3">
                    <CancelButton
                        containerProps={{
                            as: Link,
                            to: `/periodos-academicos`
                        }}
                    />
                    <Button disabled={loading} variant="success" className="float-end" onClick={() => handleSubmit()}>Salvar</Button>
                </div>
            </Form>
        );
    };
}

export default AcademicPeriodSchoolDaysForm;